// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__svCbl","info":"Note_info__m5sqw","note":"Note_note__2HyQY","actions":"Note_actions__1EktN"};